import React from 'react';
import Lottie from "lottie-react";
import itJaon from "../LoadingSvg/it.json";

const ITloading = () => {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                // height: "80svh",
            }}
        >
            <Lottie
                animationData={itJaon}
                loop={true}
                style={{ width: "300px", height: "300px" }}
                className='svges'
            />
        </div>
    )
}

export default ITloading